// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { cardTitle, grayColor } from 'styles/jss/original/base';

import tooltipsStyle from 'styles/jss/nextjs-material-kit-pro/tooltipsStyle.js';

const styles = {
  ...tooltipsStyle,
  cardTitle: {
    ...cardTitle,
    textAlign: 'center'
  },
  cardCategory: {
    textAlign: 'center',
    marginTop: '10px',
    color: grayColor[0]
  },
  cardBody: {
    padding: '0.9375rem 1.25rem',
    '@media (max-width: 640px)': {
      padding: '0.9375rem 0.625rem 0'
    }
  },
  cardFooter: {
    justifyContent: 'flex-end',
    padding: '0.9375rem 1.25rem 0.9375rem 1.875rem',
    '@media (max-width: 640px)': {
      padding: '0.9375rem 0.625rem'
    }
  },
  flex: {
    display: 'flex'
  }
};

export default styles;
